export default __webpack_public_path__ + "static/media/product.b95b288b.svg";